import {
  IconAnalytics,
  IconBell,
  IconBinocularsGray,
  IconChainLink,
  IconChartBar,
  IconChartBarGray,
  IconChartRadius,
  IconClockGray,
  IconCloudCheckGray,
  IconDashboard,
  IconLayers,
  IconLocation,
  IconRoute,
  IconRulerGray,
  IconSearch,
  IconSecurity,
  IconShareGray,
  IconTagGray,
  IconTvocGray,
  IconWarning,
  IconZoneGray,
} from '@assets/images/icon';
import { rtlsSystem } from '@assets/images/solution';
import mainVideo from '@src/assets/images/solution/constructionSafety/video/rtlsVideo.mp4';

import image1 from '@src/assets/images/solution/constructionSop/img/1.avif';
import image2 from '@src/assets/images/solution/constructionSop/img/2.avif';
import image3 from '@src/assets/images/solution/constructionSop/img/3.avif';
import image4 from '@src/assets/images/solution/constructionSop/img/4.avif';
import image5 from '@src/assets/images/solution/constructionSop/img/5.avif';
import image6 from '@src/assets/images/solution/constructionSop/img/6.avif';
import image7 from '@src/assets/images/solution/constructionSop/img/7.avif';
import image8 from '@src/assets/images/solution/constructionSop/img/8.avif';

export default {
  type: 'Giải pháp Phòng cháy chữa cháy',

  banner: {
    title: 'Xác minh hiệu quả huấn luyện phòng cháy chữa cháy dựa trên dữ liệu.',
    desc: 'Theo dõi vị trí lính cứu hỏa theo thời gian thực để đánh giá khách quan độ chính xác của bài huấn luyện, nâng cao hiệu quả vận hành.',
  },

  // video: {
  //   title: 'Tự động phát hiện và xử lý sự cố dựa trên quy trình chuẩn hóa',
  //   desc: 'Giám sát lộ trình và yếu tố nguy hiểm của công nhân theo thời gian thực, tự động cảnh báo, ghi log và xử lý theo SOP để đảm bảo an toàn có hệ thống. Dữ liệu được lưu tự động phục vụ phân tích và kiểm toán sau này.',
  //   play: mainVideo,
  // },

  summary: {
    function: {
      title: 'Số hoá việc đánh giá chính xác và quản lý huấn luyện phòng cháy chữa cháy.',
      desc: 'Phân tích và quản lý quy trình, kết quả huấn luyện một cách khách quan và hiệu quả dựa trên dữ liệu vị trí theo thời gian thực của lính cứu hỏa.',
      card: [
        {
          image: '',
          title: 'Hiển thị bản đồ nhiệt lộ trình di chuyển',
          desc: 'Ghi lại chi tiết lộ trình và đường di chuyển của lính cứu hỏa dưới dạng dữ liệu chính xác, phục vụ đánh giá mức độ hoàn thành mục tiêu huấn luyện. Phân tích độ chính xác dựa trên dữ liệu thực tế và xác định rõ điểm cần cải thiện.',
        },
        {
          title: 'Phân tích chi tiết dữ liệu lộ trình di chuyển',
          desc: 'Ghi lại chi tiết lộ trình và đường di chuyển của lính cứu hỏa dưới dạng dữ liệu chính xác, phục vụ đánh giá mức độ hoàn thành mục tiêu huấn luyện. Phân tích độ chính xác dựa trên dữ liệu thực tế và xác định rõ điểm cần cải thiện.',
        },
        {
          title: 'Đảm bảo độ chính xác dữ liệu vị trí',
          desc: 'TwinTracker cho phép nhận và lưu vị trí lính cứu hỏa theo thời gian thực không sai số, hỗ trợ phân tích chính xác lộ trình và vị trí trong quá trình huấn luyện. Dữ liệu chính xác giúp nâng cao độ tin cậy của đánh giá và quản lý vận hành hiệu quả.',
        },
        {
          title: 'Giám sát vận hành tổng hợp theo thời gian thực',
          desc: 'Quản lý toàn bộ không gian huấn luyện theo thời gian thực thông qua TwinTracker đã lắp đặt, nhanh chóng nắm bắt tình hình huấn luyện, tăng hiệu quả vận hành và tốc độ phản ứng.',
        },
      ],
    },
  },

  numOfCard: {
    title: 'Tối ưu hiệu quả vận hành với đánh giá huấn luyện dựa trên dữ liệu',
    desc: 'Cải thiện quản lý hiện trường chính xác và hiệu quả nhờ dữ liệu huấn luyện khách quan.',
    card: [
      {
        tag: '97%',
        title: 'Độ chính xác ghi tự động lộ trình huấn luyện',
        desc: 'Ghi lại lộ trình và vị trí lính cứu hỏa theo thời gian thực với độ chính xác cao, tối đa hoá độ tin cậy của việc đánh giá huấn luyện.',
      },
      {
        tag: '95%',
        title: 'Độ phủ theo dõi và giám sát theo thời gian thực',
        desc: 'Bao quát toàn bộ khu vực huấn luyện và toàn bộ nhân sự, đảm bảo giám sát theo thời gian thực không bỏ sót.',
      },
      {
        tag: '99%',
        title: 'Độ khớp cấu trúc giữa thực tế và bản đồ số',
        desc: 'Tái hiện cấu trúc hiện trường chính xác trên bản đồ số, đảm bảo độ khớp tuyệt đối với thực tế.',
      },
    ],
  },

  func: [
    {
      theme: 'Tăng độ chính xác huấn luyện<br/>với chức năng theo dõi vị trí lính cứu hỏa.',
      title: 'Triển khai TwinTracker tối ưu theo thực địa để theo dõi chính xác',
      desc: 'Phân tích cấu trúc thực tế như toa tàu điện ngầm, cầu thang, hành lang trong khu huấn luyện, lắp TwinTracker tại vị trí tối ưu. Bố trí phù hợp và cấu hình hiệu quả theo đặc điểm từng nơi, đảm bảo theo dõi vị trí lính cứu hỏa không sai lệch.',
      sub1: 'Độ chính xác cao',
      icon1: IconRulerGray,
      sub2: 'Theo dõi trạng thái theo thời gian thực',
      icon2: IconClockGray,
      image: image1,
    },
    {
      title: 'Nhận dữ liệu chính xác qua TwinTracker tại hiện trường',
      desc: 'TwinTracker lắp đặt tại hiện trường có thể nhận dữ liệu vị trí chính xác, ổn định ngay cả bên trong toa tàu điện ngầm hay các cấu trúc phức tạp mà không bị nhiễu. Độ chính xác cao đảm bảo thông tin vị trí lính cứu hỏa luôn tin cậy.',
      sub1: 'Đồng bộ dữ liệu nhanh',
      icon1: IconBinocularsGray,
      sub2: 'Theo dõi vị trí theo thời gian thực',
      icon2: IconTvocGray,
      image: image2,
    },
    {
      title: 'Môi trường theo dõi vị trí số hoá dựa trên cấu trúc thực địa',
      desc: 'Tái hiện chi tiết cấu trúc hiện trường và toa tàu điện ngầm trên bản đồ số, giám sát trực quan chuyển động của lính cứu hỏa. Phản ánh chính xác cấu trúc và vật cản, đảm bảo tính nhất quán giữa thực tế và màn hình số, cung cấp dữ liệu vị trí chính xác theo thời gian thực.',
      sub1: 'Theo dõi vị trí theo thời gian thực',
      icon1: IconBinocularsGray,
      sub2: 'Độ chính xác cao',
      icon2: IconRulerGray,
      image: image3,
    },
    {
      title: 'Xây dựng giải pháp theo dõi nhất quán từ bản vẽ đến 3D',
      desc: 'Triển khai TwinTracker dựa trên bản vẽ thiết kế chi tiết, kèm hình ảnh lắp đặt thực tế để kiểm tra tình trạng triển khai. Kết nối với giao diện giám sát trực quan và môi trường hiển thị 3D sống động, mang lại giải pháp theo dõi vị trí nhất quán từ lắp đặt đến vận hành.',
      sub1: 'Cài đặt vùng linh hoạt',
      icon1: IconZoneGray,
      sub2: 'Quản lý nhiều khu vực',
      icon2: IconTagGray,
      image: image4,
    },
  ],

  customer: {
    title: 'Cảm nhận thực tế từ khách hàng đã tin dùng ORBRO',
    card: [
      {
        desc: 'Trước đây huấn luyện phòng cháy chữa cháy chủ yếu đánh giá dựa trên kinh nghiệm và trực giác. Nhờ hệ thống theo dõi vị trí theo thời gian thực của ORBRO, chúng tôi có thể kiểm soát chính xác quá trình huấn luyện và lộ trình di chuyển của lính cứu hỏa. Việc xác minh kết quả huấn luyện bằng dữ liệu khách quan đã nâng cao độ tin cậy và hiệu quả đánh giá. Chúng tôi kỳ vọng hệ thống sẽ hỗ trợ đắc lực cho công tác thực địa trong tương lai.',
        name: 'Cục Phòng Cháy Chữa Cháy TP. Seoul',
      },
    ],
  },

  subfunc: {
    title: 'Tóm tắt tính năng chính',
    desc: 'Đảm bảo an toàn cho công nhân giúp tăng hiệu quả và giảm thiểu thiệt hại do tai nạn. ORBRO cung cấp các tính năng tối ưu để bảo vệ an toàn cho công nhân tại công trường. Hệ thống được thiết kế để phản ứng phù hợp khi công nhân tiếp cận khu vực nguy hiểm, xảy ra tai nạn hoặc phát sinh các tình huống rủi ro liên quan đến máy móc hạng nặng.',

    data: [
      {
        icon: IconLocation,
        title: 'Theo dõi vị trí theo thời gian thực',
        desc: 'Theo dõi vị trí lính cứu hỏa tại hiện trường theo thời gian thực với độ chính xác cao.',
      },
      {
        icon: IconChartBar,
        title: 'Triển khai chính xác & nhận dữ liệu ổn định',
        desc: 'Lắp đặt tối ưu tại hiện trường để đảm bảo dữ liệu vị trí chính xác và ổn định.',
      },
      {
        icon: IconAnalytics,
        title: 'Hiển thị bản đồ nhiệt lộ trình di chuyển',
        desc: 'Biểu thị khu vực tập trung hoạt động trong huấn luyện dưới dạng bản đồ nhiệt để đánh giá trực quan.',
      },
      {
        icon: IconRoute,
        title: 'Tự động ghi lộ trình huấn luyện',
        desc: 'Tự động ghi lộ trình di chuyển của lính cứu hỏa, phục vụ đánh giá khách quan dựa trên dữ liệu.',
      },
      {
        icon: IconLayers,
        title: 'Tái hiện bản đồ số cấu trúc hiện trường',
        desc: 'Tái hiện chính xác cấu trúc hiện trường trên bản đồ số để đảm bảo tính nhất quán tối đa.',
      },
      {
        icon: IconLayers,
        title: 'Quản lý huấn luyện dựa trên 3D',
        desc: 'Sử dụng mô hình 3D để hiển thị rõ ràng tiến độ và trạng thái huấn luyện.',
      },
      {
        icon: IconLocation,
        title: 'Nhận dữ liệu vị trí đáng tin cậy',
        desc: 'Cung cấp dữ liệu vị trí ổn định, không nhiễu ngay cả trong môi trường phức tạp như kết cấu tòa nhà hoặc toa tàu điện ngầm.',
      },
      {
        icon: IconSearch,
        title: 'Quản lý liên kết bản vẽ triển khai',
        desc: 'Từ bản vẽ lắp đặt đến giám sát, hiển thị 3D, cung cấp giải pháp theo dõi vị trí nhất quán.',
      },
    ],
  },

  system: {
    title: 'Cấu hình hệ thống',
    img: rtlsSystem,
  },

  productTitle: 'Cấu phần sản phẩm',
  product: [{ tag: 'workerPackage' }, { tag: 'assetPackage' }],

  contents: [{ data: 'constructionAsset' }, { data: 'constructionEquipment' }, { data: 'blogRTLS' }, { data: 'blogMedical' }],
};
